<template>
  <div class="gradebook">
    <!-- <pre>{{ gradebook_data }}</pre> -->

    <div class="width-66 width-sm-100 mx-auto">
      <div class="editable_report_block" :class="{ hidden: savePreview }">
        <div class="grade-block border-top">
          <div class="student-info">
            <h4>{{ student_name }}</h4>
            <div class="grade-badge">
              <b>Marks (in %):</b>
              <p class="grade">{{ total_mark_obtained }}</p>
            </div>
          </div>
          <vs-row class="my-2">
            <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <vs-row>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <b>Class:</b>
                </vs-col>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <p style="white-space: normal; word-break: break-word">
                    {{class_name }}
                  </p>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <vs-row>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <b>School:</b>
                </vs-col>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <p style="white-space: normal; word-break: break-word">
                    {{ school_name }}
                  </p>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <vs-row>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <b>Class Teacher:</b>
                </vs-col>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <p style="white-space: normal; word-break: break-word">
                    {{ class_teacher_name }}
                  </p>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <vs-row>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <b>Grade:</b>
                </vs-col>
                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                  <p style="white-space: normal; word-break: break-word">{{ final_result_grade.toUpperCase() }}</p>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>

        <vs-collapse class="grade-block">
          <vs-collapse-item v-for="subject in gradebook_data.grades" :key="subject.subject_id">
            <div slot="header">{{ subject.subject }}</div>
            
            <vs-collapse>
              <vs-collapse-item>
                <div slot="header">Exam</div>
                
                <div class="flex sm:flex-wrap justify-between" v-for="(exams, eidx) in subject.assignments.exam" :key="eidx">
                  <div class="w-full">
                    <div class="each-grade justify-between">
                      <b>{{ exams.title }}</b>
                      <div class="number-holder">
                        <p>{{ exams.marks_obtained_calculated }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-collapse-item>

              <vs-collapse-item>
                <div slot="header">Homework</div>

                <div class="flex sm:flex-wrap justify-between" v-for="(homeworks, hidx) in subject.assignments.homework" :key="hidx">
                  <div class="w-full">
                    <div class="each-grade justify-between">
                      <b>{{ homeworks.title }}</b>
                      <div class="number-holder">
                        <p>{{ homeworks.marks_obtained_calculated }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </vs-collapse-item>
        </vs-collapse>

        <!-- <vs-collapse class="grade-block">
          <vs-collapse-item>
            <div slot="header">Report</div>
            <div>
              <vs-row v-for="(reportItem, index) in report_details" :key="index">
                <vs-col class="p-1" vs-w="12" v-if="reportItem.question_answer">
                  <b class="mr-4">{{reportItem.question_title}}</b>
                  <p>{{reportItem.question_answer}}</p>
                  <p>{{reportItem.teacher_comment}}</p>
                </vs-col>
              </vs-row>
            </div>
          </vs-collapse-item>
        </vs-collapse> -->

        <div class="grade-block border-top feedback-block">
          <div class="header p-4">
            <vs-row>
              <vs-col class="sm:flex items-center" vs-lg="6" vs-sm="12">
                <span class="mr-2">Result Status</span>
                <v-select
                  class="w-full finall_result"
                  label="text"
                  :reduce="(option) => option.text"
                  :options="[
                    { id: 1, text: 'Qualified' },
                    { id: 2, text: 'Disqualified' },
                  ]"
                  v-model="final_result"
                  :clearable="false"
                  name="final_result"
                ></v-select>
              </vs-col>
              <vs-col class="sm:flex items-center" vs-lg="6" vs-sm="12">
                <span class="mr-2 sm:ml-2">Grade</span>
                <vs-input
                  class="finall_grade w-full"
                  v-model="final_result_grade"
                  style="display: inline-block"
                />
              </vs-col>
            </vs-row>
          </div>
        </div>
        <div class="grade-block border-top feedback-block">
          <div class="header p-4">
            <p>Teacher's Feedback</p>
          </div>
          <div class="my-4 p-4">
            <vs-textarea v-model="teacher_feedback"></vs-textarea>
            <!-- {{teacher_feedback}} -->
          </div>
        </div>
        <div class="text-center pb-4">
          <vs-button @click="saveAndPreview()">Save and Preview</vs-button>
        </div>
      </div>


      <div class="preview-holder whitespace-normal" :class="{ show: savePreview }">
        <img
          style="width: 100px"
          :src="school_logo"
          alt="logo"
        />
        <div class="sm:flex flex-wrap justify-between mt-6">
          <div>
            <div class="logo_wrapper">
              <h3 class="mb-2" style="color: rgba(var(--vs-primary), 1)">
                {{ school_name }}
              </h3>
            </div>
            <p>{{ school_address }}</p>
          </div>
          <div>
            <h4 class="mb-2">Report Card</h4>
            <div>
              <label>Date: </label>
              <strong>{{ report_date | dateFormatLocalization }}</strong>
            </div>
          </div>
        </div>
        <vs-divider />

        <div class="sm:flex flex-wrap justify-between">
          <div class="mb-4 sm:mb-0">
            <h5 class="mb-2">Student Details:</h5>
            <div>
              <label>Name: </label>
              <span>{{ student_name }}</span>
            </div>
            <div>
              <label>Class Teacher: </label>
              <span>{{ class_teacher_name }}</span>
            </div>
            <div>
              <label>Class: </label>
              <span>{{ class_name }}</span>
            </div>
          </div>
          <div>
            <h5 class="mb-2">Report Details:</h5>
            <div>
              <label>Marks: </label>
              <span>{{ total_mark_obtained }}</span>
            </div>
            <div>
              <label>Grade: </label>
              <span>{{ final_result_grade.toUpperCase() }}</span>
            </div>
          </div>
        </div>
        <div class="table-responsive cstm_vuexy_table my-4">
          <table class="all_border">
            <tbody>
              <tr>
                <th>Subject Name</th>
                <th>Gradation Component Type</th>
                <th>Marks</th>
              </tr>
              
              <template v-for="eachSubject in gradebook_data.grades">
                <tr v-for="(homework, hidx) in eachSubject.assignments.homework" :key="hidx">
                  <td :key="eachSubject.subject_id" v-if="hidx === 0" :rowspan="eachSubject.assignments.exam.length >= 1 ? eachSubject.assignments.homework.length + eachSubject.assignments.exam.length : eachSubject.assignments.homework.length">{{ eachSubject.subject }}</td>
                  <td>{{ homework.title || "" }}</td>
                  <td>{{ homework.marks_obtained_calculated !== undefined ? homework.marks_obtained_calculated : "" }}</td>
                </tr>


                <tr v-for="(exam, eidx) in eachSubject.assignments.exam" :key="eidx">
                  <td :key="eachSubject.subject_id" v-if="eidx === 0 && eachSubject.assignments.homework.length == 0"  :rowspan="eachSubject.assignments.exam.length">{{ eachSubject.subject }}</td>
                  <td>{{ exam.title || "" }}</td>
                  <td>{{ exam.marks_obtained_calculated !== undefined ?  exam.marks_obtained_calculated : "" }}</td>
                </tr>
              </template>
              
              
              <tr>
                <td>
                  <b style="margin-right: 10px"
                    >Result: <span :class="final_result === 'Disqualified' ? 'failed' : 'passed'">{{ final_result }}</span></b
                  >
                  <b style="margin-right: 10px"
                    >Grade: <span :class="final_result === 'Disqualified' ? 'failed' : 'passed'">{{ final_result_grade.toUpperCase() }}</span></b
                  >
                </td>
                <td><b>Total</b></td>
                <td>{{ total_mark_obtained }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h5 class="mt-4">Attendance - {{ attendance_details.percentage }}% ({{ attendance_details.attendance }} days present out of {{ attendance_details.scheduled }} days)</h5>
        <vs-divider />

        <h5 class="mb-2">Report:</h5>
        <div>
          <!-- <pre>{{report_details}}</pre> -->
          <vs-row v-for="(reportItem, index) in report_details" :key="index">
            <vs-col class="p-1" vs-w="12" v-for="(reports, ridx) in reportItem.report" :key="ridx">
              <!-- <pre>{{reports}}</pre> -->
              <template v-if="reports.question_answer">
                <p class="mb-4"><b>{{ reportItem.subject }}</b></p>

                <b class="ml-2">
                  Question: {{reports.question_title}}
                </b>
                <p class="ml-2"><b>Answer: </b>{{reports.question_answer}}</p>
                <p class="ml-2"><b>Feedback: </b>{{reports.teacher_comment}}</p>
              </template>
            </vs-col>
          </vs-row>
        </div>

        <vs-divider />

        <div>
          <h5>Teacher Feedback</h5>
          <p>{{ teacher_feedback }}</p>
        </div>
        <div class="mt-6 text-center">
          <vs-button class="mx-1" type="border" @click="savePreview = false" v-if="canEdit">Go Back</vs-button>
          <vs-button class="mx-1" @click="generateReport">Download As PDF</vs-button>
          <vs-button class="mx-1" @click="gradebookUpdate('final_submit')" v-if="canEdit">Save and submit</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateStudentGradebook, gradebookUpdate, gradebookDownload } from '@/api/classes'
import vSelect from 'vue-select'
import axios from 'axios'

export default {
  name: 'class-report-card',
  components: {
    vSelect
  },
  props: ['payloadForSidebar'],
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      school_logo: JSON.parse(localStorage.getItem('localization')).logo,
      submit_type:null,
      canEdit: false,
      gradebook_data: [],
      total_mark_obtained: '',
      class_name: '',
      class_teacher_name: '',
      student_name: '',
      school_name: '',
      teacher_feedback:'',
      final_result: null,
      final_result_grade: '',
      report_details:[],
      school_address: '',
      report_date: '',
      attendance_details: {},
      savePreview: false
    }
  },
  mounted () {
    this.studentGradebook(this.$route.params.payload || this.payloadForSidebar)
  },
  methods: {
    async generateReport () {
        
      this.$vs.loading({
        text: 'Generating report, please wait...'
      })

      const {data} = await gradebookDownload(this.customer_id, this.$route.params.payload || this.payloadForSidebar)

      const url = data.data.url
      // console.log('Gradebook Downoad Link : ', url)
      
      axios({
        url,
        withCredentials: false,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'Gradebook.pdf')
        document.body.appendChild(fileLink)
        
        fileLink.click()
      })

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    
    },
    async studentGradebook (payload) {
      try {
        const response = await generateStudentGradebook(this.customer_id, payload)
        this.gradebook_data = response.data.data.gradeBook

        this.class_name = this.gradebook_data.class_name
        this.class_teacher_name = `${this.gradebook_data.class_teacher_name.first_name} ${this.gradebook_data.class_teacher_name.last_name}`
        this.student_name = `${this.gradebook_data.client_user_name.first_name} ${this.gradebook_data.client_user_name.last_name}`
        this.school_name = this.gradebook_data.school_name.brand_company_name
        this.total_mark_obtained = this.gradebook_data.result
        const { address1, address2} = this.gradebook_data.school_name.platform_customer_branches
        this.school_address = `${address1}, ${address2}`
        this.report_date = this.gradebook_data.grade_card ? this.gradebook_data.grade_card.created_at : ''
        this.report_details = this.gradebook_data.reports
        this.final_result = this.gradebook_data.grade_card ? this.gradebook_data.grade_card.result : ''
        this.final_result_grade = this.gradebook_data.grade_card ? this.gradebook_data.grade_card.grade : ''
        this.teacher_feedback = this.gradebook_data.grade_card ? this.gradebook_data.grade_card.teacher_feedback : ''

        this.attendance_details = this.gradebook_data.attendance

        this.submit_type = this.gradebook_data.grade_card.submit_type
        if (this.submit_type === 'draft') {
          this.canEdit = true
        } else {
          this.canEdit = false 
          this.savePreview = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    saveAndPreview () {
      if (!this.final_result) {
        this.showSuccessMessage('You have not selected final result', 'Please select student`s final result', 'danger')
      } else if (!this.final_result_grade) {
        this.showSuccessMessage('You have not selected final grade', 'Please select student`s final grade', 'danger')
      } else {
        const submit_type = this.submit_type === 'final_submit' ? 'final_submit' : 'draft'
        this.gradebookUpdate(submit_type)
      }
    },
    async gradebookUpdate (submit_type) {
      this.$vs.loading({
        text: 'Updating gradebook...'
      })

      try {
        
        const payload = {
          client_user_id: this.$route.params.client_user_id,
          class_id: this.$route.params.class_id,
          teacher_feedback : this.teacher_feedback,
          grade : this.final_result_grade,
          result: this.final_result,
          total_marks_obtained: this.total_mark_obtained,
          submit_type
        }
        
        await gradebookUpdate(this.customer_id, payload)

        await this.studentGradebook(this.$route.params.payload)

        this.savePreview = true
        let alertText = ''
        if (this.submit_type === 'draft') {
          alertText = 'Gradebook updated'
        } else if (this.submit_type === 'final_submit') {
          alertText = 'Gradebook saved and submitted'
        }

        this.showSuccessMessage('Success', alertText, 'success')  
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')      
      } finally {
        this.$vs.loading.close()
      }
    
    }
  }
}
</script>
<style>
.passed {
  color: #28c76f;
  text-transform: uppercase;
}
.failed {
  color: #ff0000;
  text-transform: uppercase;
}
</style>